import { type ApiClient, RefKnowledges, RefSkills } from '@prismo-io/schemas';
import { z } from 'zod';
import { SkillTypeEnum } from './skill-type-enum';

const Skill = z.object({
  ref: RefSkills.pick({ name: true, code: true }),
  id: z.string(),
  type: SkillTypeEnum,
  is_known: z.boolean(),
  favorite: z.number().nullable(),
  level: z.number().nullable(),
  interest: z.number().nullable(),
  created_at: z.date({ coerce: true }),
});

export type SkillsT = z.infer<typeof Skill>;

const Knowledges = z.object({
  ref: RefKnowledges.pick({ name: true, code: true }),
  id: z.string(),
  type: SkillTypeEnum,
  is_known: z.boolean(),
  favorite: z.number().nullable(),
  level: z.number().nullable(),
  interest: z.number().nullable(),
  created_at: z.date({ coerce: true }),
});

export type KnowledgesT = z.infer<typeof Knowledges>;

export const SkillsAndKnowledges = z.object({
  skills: z.array(Skill).default([]),
  knowledges: z.array(Knowledges).default([]),
});

export type SkillsAndKnowledgesT = z.infer<typeof SkillsAndKnowledges>;

export const fetchSkillsAndKnowledges = async (
  client: ApiClient,
  userId: string
): Promise<SkillsAndKnowledgesT> => {
  const { data: user } = await client
    .from('users')
    .select(
      `
        id,
        skills:quark_users_skills(
          id,
          favorite,
          is_known,
          level,
          interest,
          created_at,
          ref:ref_skills(
            name,
            code
          )
        ),
        knowledges:quark_users_knowledges(
          id,
          favorite,
          is_known,
          level,
          interest,
          created_at,
          ref:ref_knowledges(
            name,
            code
          )
        )
      `
    )
    .eq('id', userId)
    .order('favorite', {
      nullsFirst: false,
      foreignTable: 'quark_users_skills',
    })
    .order('created_at', {
      ascending: false,
      foreignTable: 'quark_users_skills',
    })
    .order('favorite', {
      nullsFirst: false,
      foreignTable: 'quark_users_knowledges',
    })
    .order('created_at', {
      ascending: false,
      foreignTable: 'quark_users_knowledges',
    })
    .single()
    .throwOnError();

  return SkillsAndKnowledges.parse({
    skills: user?.skills.map((skill) => ({
      ...skill,
      type: SkillTypeEnum.Enum.SKILLS,
    })),
    knowledges: user?.knowledges.map((knowledge) => ({
      ...knowledge,
      type: SkillTypeEnum.Enum.KNOWLEDGE,
    })),
  });

  // const { data: s } = await client
  //   .from('quark_users_skills')
  //   .select(
  //     'id, favorite, is_known, level, interest, created_at, ref:ref_skills(name,code)'
  //   )
  //   .eq('user_id', userId)
  //   .order('favorite', { nullsFirst: false })
  //   .throwOnError();

  // const skills = s?.map((skill) => {
  //   return {
  //     ...skill,
  //     type: SkillTypeEnum.Enum.SKILLS,
  //   };
  // });

  // const { data: k } = await client
  //   .from('quark_users_knowledges')
  //   .select(
  //     'id, favorite, is_known, level, interest, created_at, ref:ref_knowledges(name,code)'
  //   )
  //   .eq('user_id', userId)
  //   .order('favorite', { nullsFirst: false })
  //   .throwOnError();

  // const knowledges = k?.map((knowledge) => {
  //   return {
  //     ...knowledge,
  //     type: SkillTypeEnum.Enum.KNOWLEDGE,
  //   };
  // });

  // return SkillsAndKnowledges.parse({ skills, knowledges });
};

export const fetchAcquiredSkillsAndKnowledges = async (
  client: ApiClient,
  userId: string
): Promise<SkillsAndKnowledgesT> => {
  const { data: user } = await client
    .from('users')
    .select(
      `
        id,
        skills:quark_users_skills(
          id,
          favorite,
          is_known,
          level,
          interest,
          created_at,
          ref:ref_skills(
            name,
            code
          )
        ),
        knowledges:quark_users_knowledges(
          id,
          favorite,
          is_known,
          level,
          interest,
          created_at,
          ref:ref_knowledges(
            name,
            code
          )
        )
      `
    )
    .eq('id', userId)
    .is('skills.is_known', true)
    .is('knowledges.is_known', true)
    .order('favorite', {
      nullsFirst: false,
      foreignTable: 'quark_users_skills',
    })
    .order('created_at', {
      ascending: false,
      foreignTable: 'quark_users_skills',
    })
    .order('favorite', {
      nullsFirst: false,
      foreignTable: 'quark_users_knowledges',
    })
    .order('created_at', {
      ascending: false,
      foreignTable: 'quark_users_knowledges',
    })
    .single()
    .throwOnError();

  return SkillsAndKnowledges.parse({
    skills: user?.skills.map((skill) => ({
      ...skill,
      type: SkillTypeEnum.Enum.SKILLS,
    })),
    knowledges: user?.knowledges.map((knowledge) => ({
      ...knowledge,
      type: SkillTypeEnum.Enum.KNOWLEDGE,
    })),
  });

  // const { data: s } = await client
  //   .from('quark_users_skills')
  //   .select(
  //     'id, favorite, is_known, level, interest, created_at, ref:ref_skills(name,code)'
  //   )
  //   .eq('user_id', userId)
  //   .eq('is_known', true)
  //   .order('favorite', { nullsFirst: false })
  //   .throwOnError();

  // const skills = s?.map((skill) => {
  //   return {
  //     ...skill,
  //     type: SkillTypeEnum.Enum.SKILLS,
  //   };
  // });

  // const { data: k } = await client
  //   .from('quark_users_knowledges')
  //   .select(
  //     'id, favorite, is_known, level, interest, created_at, ref:ref_knowledges(name,code)'
  //   )
  //   .eq('user_id', userId)
  //   .eq('is_known', true)
  //   .order('favorite', { nullsFirst: false })
  //   .throwOnError();

  // const knowledges = k?.map((knowledge) => {
  //   return {
  //     ...knowledge,
  //     type: SkillTypeEnum.Enum.KNOWLEDGE,
  //   };
  // });

  // return SkillsAndKnowledges.parse({ skills, knowledges });
};
